// extracted by mini-css-extract-plugin
module.exports = {"clubNav":"_aa831b2"};